var map = {
	"./batman.jpeg": "8147",
	"./defaultMan.jpg": "dd34",
	"./defaultWoman.jpg": "1dd9",
	"./martha.png": "ecb1",
	"./patrick.png": "508d",
	"./thomas.png": "deb4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";